import React from "react";
import { Typography } from "antd";
import { TitleProps } from "antd/lib/typography/Title";
import classNames from "classnames";
import { TestID } from "../../shared/testids/testids";
import { Merge } from "../../shared/TypeScriptHelpers";
import "./COREHeading.less";

const { Title } = Typography;

export type COREHeadingProps = Merge<
  TitleProps,
  {
    testID: TestID;
    marginBottom?: boolean;
    className?: string;
    alignCenter?: boolean;
    level?: 1 | 2 | 3 | 4 | 5 | 6;
  }
>;

export const COREHeading: React.FC<COREHeadingProps> = ({
  level,
  children,
  testID,
  marginBottom = true,
  className = "",
  alignCenter,
  ...props
}) => {
  const commonClassName = classNames(className, {
    "no-margin-bottom": !marginBottom,
    "align-center": alignCenter,
  });

  if (level === 6) {
    return (
      <span className={"core-heading"}>
        <h6
          data-testid={testID}
          className={classNames("core-heading-h6", commonClassName)}
        >
          {children}
        </h6>
      </span>
    );
  }

  return (
    <span className={"core-heading"}>
      <Title
        level={level}
        data-testid={testID}
        className={commonClassName}
        {...props}
      >
        {children}
      </Title>
    </span>
  );
};
